import { ArrowRightIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type RowAction = 'view' | 'open' | 'edit';

const ACTION_KEYS: Record<RowAction, string> = {
  view: 'common.view_action',
  open: 'common.open_action',
  edit: 'common.edit',
};

interface RowActionIndicatorProps {
  action: RowAction;
}

export const RowActionIndicator = ({ action }: RowActionIndicatorProps) => {
  const { t } = useTranslation();

  return (
    <span
      aria-hidden
      className="ml-auto inline-flex shrink-0 items-center gap-1 text-sm whitespace-nowrap text-informational opacity-0 transition-opacity duration-200 ease-out group-focus-within:opacity-100 group-hover:opacity-100 group-hover:delay-100"
    >
      {t(ACTION_KEYS[action])}
      <ArrowRightIcon className="size-3.5" />
    </span>
  );
};
